import React from 'react'
import Contractviewform from '../../components/contractreportcomponents/Contractviewform'
import LicenseReportDetails from '../../components/Licensereportcomponents/LicenseReportDetails'

function  LicenseView({renderPageContent}) {
    return (
        <>
                        <LicenseReportDetails renderPageContent={renderPageContent}/>
        </>
    )
}

export default  LicenseView